import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("small", null, "Campaign image", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Campaign name")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Campaign subDomain")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Campaign description")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Start date")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "End date")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Page to initiate after register/login")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Campaign font")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Font class")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Auto Register Secret")
], -1)
const _hoisted_13 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_AssetManagerComponent = _resolveComponent("AssetManagerComponent")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      model: _ctx.campaignData
    }, {
      default: _withCtx(() => [
        (_ctx.method == 'Update')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", {
                class: "image",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAssetManager = true)),
                style: _normalizeStyle({
					backgroundImage: `url('${_ctx.campaignData.logo}')`,
					borderStyle: _ctx.campaignData.logo ? 'solid' : 'dashed'
				})
              }, [
                (!_ctx.campaignData.logo)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      class: "add-icon",
                      icon: "plus"
                    }))
                  : _createCommentVNode("", true)
              ], 4)
            ]))
          : _createCommentVNode("", true),
        _hoisted_3,
        _createVNode(_component_a_form_item, {
          ref: "name",
          name: "name"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_a_input, {
              type: "text",
              value: _ctx.campaignData.name,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.campaignData.name) = $event)),
              placeholder: "Campaign name",
              class: "ant-input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_a_form_item, {
          ref: "subDomain",
          name: "subDomain"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_a_input, {
              type: "text",
              value: _ctx.campaignData.subDomain,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.campaignData.subDomain) = $event)),
              placeholder: "Campaign subDomain",
              class: "ant-input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_a_form_item, { name: "description" }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_a_textarea, {
              class: "ant-input",
              placeholder: "Campaign description",
              value: _ctx.campaignData.description,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.campaignData.description) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "dateRange" }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_a_date_picker, {
              allowClear: false,
              value: _ctx.startDate,
              onChange: _ctx.onStartChange,
              style: {"width":"100%"}
            }, null, 8, ["value", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "dateRange" }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_a_date_picker, {
              allowClear: false,
              value: _ctx.endDate,
              onChange: _ctx.onEndChange,
              style: {"width":"100%"}
            }, null, 8, ["value", "onChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _hoisted_9,
            _createVNode(_component_a_input, {
              type: "text",
              value: _ctx.campaignData.pageAfterAuth,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.campaignData.pageAfterAuth) = $event)),
              placeholder: "Page to initiate after auth",
              class: "ant-input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_a_textarea, {
              class: "ant-input",
              placeholder: "Example - @import url('https://fonts.googleapis.com/css2?family=Roboto:ital@1&display=swap');",
              value: _ctx.campaignData.googleFont,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.campaignData.googleFont) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _hoisted_11,
            _createVNode(_component_a_textarea, {
              class: "ant-input",
              placeholder: "Example - font-family: 'Roboto', sans-serif;",
              value: _ctx.campaignData.fontClass,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.campaignData.fontClass) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _hoisted_12,
            _createVNode(_component_a_input, {
              type: "text",
              value: _ctx.campaignData.secret,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.campaignData.secret) = $event)),
              placeholder: "Campaign secret",
              class: "ant-input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                type: "default",
                onClick: _ctx.onCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                loading: _ctx.loading,
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Submit")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_modal, {
      footer: null,
      visible: _ctx.showAssetManager,
      title: 'Assets',
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showAssetManager = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AssetManagerComponent, {
          campID: _ctx.campaignData.id,
          onSetAsset: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setAsset($event)))
        }, null, 8, ["campID"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}